export default __webpack_public_path__ + "navigation-guides-ui-steps-view-controller-1200-c5692f0f818662825a2b5e185ca4ba36.webp";